import CapturePhoneForm from "./CapturePhoneForm";
const CapturePhone = ({
  toggleSnackbar,
  recaptchaRef,
  handleModalClose,
  enquireNow = false,
  callNow = false,
  pagePath,
  songName1,
  newEnquireNowfield,
  handleTelegramPopupOpen,
}) => {
  return (
    <div className="box">
      <div className="capture-phone-container">
        {enquireNow ? (
          <h2>Enter Your Details</h2>
        ) : (
          <h2>Enter Your Mobile Number</h2>
        )}
        {!enquireNow && !callNow && (
          <span>
            We need your mobile number before we can go ahead with your request
            to Reserve NFT
          </span>
        )}
      </div>
      <CapturePhoneForm
        enquireNow={enquireNow}
        callNow={callNow}
        handleModalClose={handleModalClose}
        toggleSnackbar={toggleSnackbar}
        pagePath={pagePath}
        songName1={songName1}
        newEnquireNowfield={newEnquireNowfield}
        handleTelegramPopupOpen={handleTelegramPopupOpen}
      />
    </div>
  );
};

export default CapturePhone;
